<div class="block__right-side-panel">
    <div class="block-full-width no-padding no-border-radius">
        <div class="card-details">
            <div class="card-details-area">
                <h2 class="card-details-area__title margin-bottom-10">
                    {{ 'PERSONALIZE_FORM_TITLE' | translate }}
                </h2>
                <p class="required-text">{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>

                <form [formGroup]="_personalizeForm" (ngSubmit)="submitForm()" ridangoFocusInvalidInput>
                    <div class="card-details-area__card-number">
                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="_personalizeForm.controls.card_id"
                                ridangoInput
                                name="travelcard[card_id]"
                                required />
                            <ridango-label>{{ 'PH_CARD_NUMBER' | translate }}</ridango-label>

                            <ridango-error *ngIf="_personalizeForm.controls['card_id']?.hasError('pattern')">
                                {{ 'FIELD_VALIDATION_CARD_NUMBER_INVALID_FORMAT' | translate }}
                            </ridango-error>

                            <ridango-error *ngIf="_personalizeForm.controls['card_id']?.hasError('required')">
                                {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                            </ridango-error>
                        </ridango-form-field>
                    </div>

                    <div class="card-details-area__card-number" *ngIf="!!_personalizeForm.controls['personal_code']">
                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="_personalizeForm.controls['personal_code']"
                                ridangoInput
                                name="travelcard['personal_code']"
                                required />
                            <ridango-label>{{ 'PH_PERSONAL_CODE' | translate }}</ridango-label>

                            <ridango-error *ngIf="_personalizeForm.controls['personal_code']?.hasError('required')">
                                {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                            </ridango-error>

                            <ridango-error *ngIf="_personalizeForm.controls['personal_code']?.hasError('pattern')">
                                {{ 'FIELD_VALIDATION_PERSONAL_NUMBER_INVALID_FORMAT' | translate }}
                            </ridango-error>

                            <ridango-error *ngIf="_personalizeForm.controls['personal_code']?.hasError('personalCode')">
                                {{ 'LOCAL_PERSONALIZATION_PERSONAL_CODE_WRONG_FORMAT_ERROR' | translate }}
                            </ridango-error>
                        </ridango-form-field>
                    </div>

                    <div class="card-details-area__card-number" *ngIf="!isStronglyAuth">
                        <ridango-form-field class="form-margin-10">
                            <input
                                [formControl]="_personalizeForm.controls.id_card"
                                ridangoInput
                                name="travelcard.id_card"
                                required />
                            <ridango-label>{{ 'PH_ID_CARD_NUMBER' | translate }}</ridango-label>

                            <ridango-error *ngIf="_personalizeForm.controls.id_card?.hasError('required')">
                                {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                            </ridango-error>

                            <ridango-error *ngIf="_personalizeForm.controls.id_card?.hasError('pattern')">
                                {{ 'FIELD_VALIDATION_ID_CARD_NUMBER_INVALID_FORMAT' | translate }}
                            </ridango-error>
                        </ridango-form-field>
                    </div>

                    <div class="item-tnc" *ngIf="terms">
                        <span class="checkbox-wcag">
                            <input
                                class="checkbox-wcag__checkbox"
                                type="checkbox"
                                attr.aria-hidden="true"
                                formControlName="terms"
                                required
                                attr.aria-required="true"
                                tabindex="-1"
                                attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }} {{
                                    'ASTERISK' | translate
                                }}" />

                            <span
                                class="checkbox-wcag__checkmark"
                                (click)="toggleCheckbox()"
                                (keydown.space)="toggleCheckbox()"
                                tabindex="0"
                                attr.aria-checked="{{ termsAgreed }}"
                                role="checkbox"
                                required
                                attr.aria-required="true"
                                attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }} {{
                                    'ASTERISK' | translate
                                }}">
                            </span>

                            <label class="checkbox-wcag__label checkbox-wcag__label--large-offset">
                                <span>
                                    <span
                                        class="link-label"
                                        (click)="toggleCheckbox()"
                                        (keydown.enter)="toggleCheckbox()"
                                        (keydown.space)="toggleCheckbox()">
                                        {{ 'READ_TERMS' | translate }}
                                    </span>

                                    <a
                                        class="link link--emphasized link--action"
                                        #modalTrigger
                                        (click)="openTerms()"
                                        (keydown.enter)="openTerms()"
                                        (keydown.space)="openTerms()"
                                        tabindex="0"
                                        role="link">
                                        {{ 'WITH_TERMS_AND_CONDITIONS' | translate }}
                                    </a>
                                </span>
                            </label>
                        </span>
                    </div>

                    <div class="item-tnc" *ngIf="env.BENEFICIAL_CHECKBOX">
                        <div class="checkbox-wcag flex items-start">
                            <input
                                class="checkbox-wcag__checkbox"
                                [checked]="beneficial"
                                type="checkbox"
                                aria-hidden="true"
                                tabindex="-1" />

                            <span
                                class="checkbox-wcag__checkmark"
                                [attr.aria-checked]="beneficial"
                                [attr.aria-label]="'BENEFICIAL_CHECKBOX_ARIA_LABEL' | translate"
                                (click)="toggleBeneficialCheckbox()"
                                (keydown.space)="toggleBeneficialCheckbox()"
                                role="checkbox"
                                tabindex="0"></span>
                            <label
                                class="checkbox-wcag__label checkbox-wcag__label--large-offset"
                                (click)="toggleBeneficialCheckbox()"
                                (keydown.enter)="toggleBeneficialCheckbox()"
                                (keydown.space)="toggleBeneficialCheckbox()">
                                {{ 'BENEFICIAL_CHECKBOX_LABEL' | translate }}
                            </label>
                        </div>
                        <ul class="ml-16 list-disc pt-4">
                            <li>{{ 'BENEFICIAL_TEXT_PARENT' | translate }}</li>
                            <li>{{ 'BENEFICIAL_TEXT_PERSON_WITH_DISABILITY' | translate }}</li>
                        </ul>
                    </div>

                    <button
                        class="btn btn--maximal btn--primary btn--big"
                        [disabled]="_personalizeForm.invalid || (personalizingLoading$ | async)"
                        [attr.aria-label]="'BTN_PERSONALIZE' | translate"
                        type="submit">
                        <ng-container *ngIf="personalizingLoading$ | async; else buttonText">
                            <span class="btn-loader">
                                <span>
                                    <span class="btn-loader__img"
                                        ><img src="assets/button_loader.png" aria-hidden="true"
                                    /></span>
                                    <span class="btn-loader__text">{{ 'BUTTON_LOADER_TEXT' | translate }}</span>
                                </span>
                            </span>
                        </ng-container>
                        <ng-template #buttonText>
                            {{ 'BTN_PERSONALIZE' | translate }}
                        </ng-template>
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>

<ridango-modal #modal [size]="'800'" [visible]="termsVisible" [isItSmall]="true" (onCloseModal)="closeTerms()">
    <ridango-terms-modal-content [termsUrl]="termsUrl" (onAgree)="agreeTerms($event)"></ridango-terms-modal-content>
</ridango-modal>
